import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrDocumentPlusIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M3.7 1.6998C3.53431 1.6998 3.4 1.83412 3.4 1.9998V13.9998C3.4 14.1655 3.53431 14.2998 3.7 14.2998H12.2C12.3657 14.2998 12.5 14.1655 12.5 13.9998V5.6998H9.90654C8.96766 5.6998 8.20654 4.93869 8.20654 3.9998V1.6998H3.7ZM9.60654 2.60867V3.9998C9.60654 4.16549 9.74086 4.2998 9.90654 4.2998H11.4218L9.60654 2.60867ZM2 1.9998C2 1.06092 2.76112 0.299805 3.7 0.299805H8.90654C9.08363 0.299805 9.25414 0.366923 9.3837 0.487635L13.6772 4.48764C13.8193 4.62005 13.9 4.80556 13.9 4.9998V13.9998C13.9 14.9387 13.1389 15.6998 12.2 15.6998H3.7C2.76111 15.6998 2 14.9387 2 13.9998V1.9998Z'
      fill='currentColor'
    />
    <path
      d='M8.36728 7.36843C8.36728 7.16495 8.20239 7 7.99899 7C7.79558 7 7.63068 7.16494 7.63068 7.36841L7.63064 9.63672H5.3683C5.16489 9.63672 5 9.80167 5 10.0051C5 10.2086 5.16489 10.3736 5.3683 10.3736H7.63062L7.63058 12.6316C7.63058 12.835 7.79547 13 7.99888 13C8.20228 13 8.36718 12.8351 8.36718 12.6316L8.36723 10.3736H10.6317C10.8351 10.3736 11 10.2086 11 10.0051C11 9.80167 10.8351 9.63672 10.6317 9.63672H8.36724L8.36728 7.36843Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrDocumentPlusIconComponent;
